import * as Yup from 'yup';

export default Yup.object().shape({
  code: Yup.string().required('Please provide confirmation code'),
  userName: Yup.string().required('Please provide username')
});
